import styled from 'styled-components'

export const ItemWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

export const CoverWrap = styled.div`
  position: relative;
  width: 5rem; /* w-20 */
  height: 5rem;
  flex: 0 0 auto; /* flex-none */
`

export const CoverImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.125rem; /* rounded-sm */
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Transparent = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const PlayButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
`

export const PlayImg = styled.img`
  width: 100%;
  height: 100%;
`

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin-left: 1rem; /* ml-4 */
  padding-right: 1rem; /* pr-4 */
  flex: 1 1 auto; /* flex-grow */
  min-width: 0; /* allow truncation */
`

